module.exports = __webpack_public_path__ + "static/media/back-arrow-white.f683190f.svg";